import React from 'react'
import { Row, Cell } from '../../../components/Table'
import { DropDown, DropDownItem, ICONS } from '../../../components/DropDown'
import { getMessage } from '../../../lib/translator'
import { TABLE_ACTIONS } from '../../../containers/ListingPage'

const TableRow = ({ sk, pk, domain, isDisabled, onAction }) => (
  <Row>
    <Cell className="whitelist-domain-table-id">{sk}</Cell>
    <Cell className="whitelist-domain-table-domain">{domain}</Cell>
    <Cell className="whitelist-domain-table-status">
      {isDisabled
        ? getMessage('whitelistDomain.status.disabled')
        : getMessage('whitelistDomain.status.enabled')}
    </Cell>
    <Cell className="whitelist-domain-table-actions">
      <DropDown icon={<img src={ICONS.VELLIP} alt="⋮" />}>
        {isDisabled ? (
          <DropDownItem
            onClick={() => {
              onAction(TABLE_ACTIONS.UPDATE, { sk, pk }, { isDisabled: false })
            }}
          >
            {getMessage('whitelistDomain.action.enable')}
          </DropDownItem>
        ) : (
          <DropDownItem
            onClick={() => {
              onAction(TABLE_ACTIONS.UPDATE, { sk, pk }, { isDisabled: true })
            }}
          >
            {getMessage('whitelistDomain.action.disable')}
          </DropDownItem>
        )}
      </DropDown>
    </Cell>
  </Row>
)

export const tableProperties = () => ({
  headers: [
    getMessage('whitelistDomain.column.id'),
    getMessage('whitelistDomain.column.domain'),
    getMessage('whitelistDomain.column.status'),
    getMessage('whitelistDomain.column.action'),
  ],
  row: (props) => <TableRow {...props} />,
})
